import { useGetListResourceData } from 'modules/missionControl/components/Launchpad/hooks/useGetListResourceData';
import { getListUrl } from 'utils/appRoutes';
import { ActivityItem as ActivityItemType } from '../Launchpad.types';
import { ActivityItem } from './ActivityItem';

export const ListItem = (props: {
  item: ActivityItemType;
  titleWidth: number;
}) => {
  // Resource data
  const { resource, isLoading, hasError } = useGetListResourceData(props.item.resourceId);

  // Resource url
  const url = getListUrl(resource.id);

  return (
    <ActivityItem
      {...props}
      isHidden={!resource.id}
      isLoading={isLoading}
      hasError={hasError}
      resource={resource}
      url={url}
    />
  );
};
